<p>{{ 'lib.text-field-component.error' | translate }}</p>
